import { Link, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/App";
import { LayoutDashboard, Home, CalendarDays, Sparkles, UtensilsCrossed, Star, ShoppingCart, Package, Users, LogOut, ChevronLeft, Menu, Award, BarChart3, Settings, TreePine, CreditCard } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const ADMIN_NAV = [
  { href: "/admin", label: "Дашборд", icon: LayoutDashboard },
  { href: "/admin/analytics", label: "Аналитика", icon: BarChart3 },
  { href: "/admin/bookings", label: "Бронирования", icon: CalendarDays },
  { href: "/admin/orders", label: "Заказы", icon: ShoppingCart },
  { href: "/admin/payments", label: "Оплаты Kaspi", icon: CreditCard },
  { href: "/admin/clients", label: "Клиенты", icon: Users },
  { href: "/admin/loyalty", label: "Лояльность", icon: Award },
  { href: "/admin/inventory", label: "Бар", icon: Package },
  { href: "/admin/houses", label: "Банные дома", icon: Home },
  { href: "/admin/venues", label: "Летник", icon: TreePine },
  { href: "/admin/services", label: "Услуги", icon: Sparkles },
  { href: "/admin/menu", label: "Меню", icon: UtensilsCrossed },
  { href: "/admin/reviews", label: "Отзывы", icon: Star },
  { href: "/admin/settings", label: "Настройки", icon: Settings },
];

function SidebarContent({ onNavigate }) {
  const location = useLocation();
  const { user, logout } = useAuth();
  const isActive = (href) => location.pathname === href;

  return (
    <div className="flex flex-col h-full">
      <div className="p-4 border-b border-white/5">
        <Link to="/" className="block" onClick={onNavigate}>
          <img src="https://customer-assets.emergentagent.com/job_70076dd7-e4cb-484b-b629-fe23ba9127e6/artifacts/3zpuxtd5_LOGO.PNG" alt="Eco Village" className="h-10" />
        </Link>
        <p className="text-xs text-muted-foreground mt-1">Админ-панель</p>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {ADMIN_NAV.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            onClick={onNavigate}
            className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${
              isActive(item.href)
                ? "bg-primary/10 text-primary"
                : "text-muted-foreground hover:text-foreground hover:bg-white/5"
            }`}
            data-testid={`admin-nav-${item.href.split("/").pop() || "dashboard"}`}
          >
            <item.icon className="w-4 h-4" />
            {item.label}
          </Link>
        ))}
      </nav>
      <div className="p-3 border-t border-white/5">
        <p className="text-xs text-muted-foreground px-3 mb-2 truncate">{user?.email}</p>
        <button
          onClick={() => { logout(); onNavigate?.(); }}
          className="flex items-center gap-3 px-3 py-2 text-sm text-muted-foreground hover:text-destructive transition-colors w-full"
          data-testid="admin-logout-btn"
        >
          <LogOut className="w-4 h-4" /> Выход
        </button>
      </div>
    </div>
  );
}

export default function AdminLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex">
      {/* Desktop Sidebar */}
      <aside className="hidden md:block w-60 admin-sidebar fixed top-0 left-0 h-screen z-40" data-testid="admin-sidebar">
        <SidebarContent />
      </aside>

      {/* Mobile Header */}
      <div className="md:hidden fixed top-0 w-full z-50 bg-background/90 backdrop-blur-md border-b border-white/5 h-14 flex items-center px-4 justify-between">
        <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
          <SheetTrigger asChild>
            <button className="p-2" data-testid="admin-mobile-menu">
              <Menu className="w-5 h-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="bg-card border-r border-white/5 w-[260px] p-0">
            <SidebarContent onNavigate={() => setMobileOpen(false)} />
          </SheetContent>
        </Sheet>
        <span className="font-serif text-sm"><span className="text-primary">ECO</span>VILLAGE</span>
        <div className="w-9" />
      </div>

      {/* Main Content */}
      <main className="flex-1 md:ml-60 min-h-screen" data-testid="admin-main-content">
        <div className="p-4 md:p-6 lg:p-8 mt-14 md:mt-0">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
